export default class ActivitiesListCtrl {

	constructor ($scope, WorkPlanSrv, $mdDialog, WorkPlanIndicatorSrv, WorkPlanModalSrv, $cookies, GlobalConfig, Requests, $sessionStorage) {
		this.currentUser = JSON.parse($cookies.get('currentUser'))
		this.activities = []
		this.active = GlobalConfig.generals.active
		this.planningFinish = true
		this.$scope = $scope
		this.$scope.classPlanning = ''
		this.inReview = 0
		this.feedback = 0
		this.workPlanGeneralList = $sessionStorage.workPlanGeneralList
		this.$sessionStorage = $sessionStorage
		this.WorkPlanSrv = WorkPlanSrv
		this.WorkPlanIndicatorSrv = WorkPlanIndicatorSrv
		this.WorkPlanModalSrv = WorkPlanModalSrv
		this.GlobalConfig = GlobalConfig
		this.$mdDialog = $mdDialog
		this.activate()
	}

	activate () {
		let post = {
			teacherId : this.currentUser.teacherId,
			workplanId: this.currentUser.workplanId,
		}

		if (this.workPlanGeneralList != undefined) {
			this.status = this.workPlanGeneralList.wokplanTeacherStatus[0]
			this.stages = this.workPlanGeneralList.stages
			this.inReview = this.status.reviewed
			this.feedback = this.status.feedbackReviewed
			this.workplanTeacherId = this.status.workplanTeacherId
			this.isPlanning(this.status, this.stages)
      
			if (this.feedback && !this.planningFinish) {
				this.getOtherActivitiesReject(post)
			} else {
				this.getActivities()
			}
		} else {
			this.getGeneralsWorkplan(post).then((promise) => {
				if (this.feedback && !this.planningFinish) {
					this.getOtherActivitiesReject(post)
				} else {
					this.getActivities()
				}
			})
		}
	}

	getActivities () {
		let post = {
			idTeacher : this.currentUser.teacherId,
			idWorkPlan: this.currentUser.workplanId,
		}

		this.WorkPlanSrv.getActivities.getList(post).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.activities = dataReturn.data
			} else {
				console.log('Comunications problem with the server')
			}
		}, (data) => {
			console.log(data)
		})
	}

	getOtherActivitiesReject (post) {
		this.WorkPlanSrv.getOtherActivitiesReject.getList(post).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				// console.log("dataReturn-->", dataReturn)
				this.activities = dataReturn.data
			} else {
				console.log('Comunications problem with the server')
			}
		}, (data) => {
			console.log(data)
		})
	}

	getGeneralsWorkplan (post) {
		return this.WorkPlanSrv.getElementsRightBar.getList({ teacherId: post.teacherId }).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.$sessionStorage.workPlanGeneralList = dataReturn.data
				this.status = dataReturn.data.wokplanTeacherStatus[0]
				this.stages = dataReturn.data.stages
				this.inReview = this.status.reviewed
				this.feedback = this.status.feedbackReviewed
				this.workplanTeacherId = this.status.workplanTeacherId
				this.isPlanning(this.status, this.stages)
			} else {
				console.log('Comunications problem with the server')
			}
		}, (data) => {
			console.log(data)
		})
	}

	isPlanning (status, stages) {
		this.currentDate = moment(new Date()).format('YYYY-MM-DD')
		for (var i = stages.length - 1; i >= 0; i--) {
			if (stages[i].stageId == this.GlobalConfig.workplanIdStages.review) {
				this.startDateStage = stages[i].startDate
			}
		}

		if (status.workplanActive) {
			if (status.planningFinish == this.active) {
				this.planningFinish = true

				if (this.startDateStage < this.currentDate || status.reviewedFinish == this.active) {
					this.planningFinish = true
				} else if (status.reviewedReject == this.active) {
					this.planningFinish = false
				}
			} else {
				this.planningFinish = false
			}
		} else {
			this.planningFinish = true
		}

		this.$scope.classPlanning = (this.planningFinish ? 'disabled' : ' ')
	}

	confirmDisableActivity (row) {
		const activityArray = this.activities.indexOf(row)
		const activityCode = row.otherActivityCode
		const deleteActivityName = row.otherActivityName

		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
				this.close = (value) => {
					$mdDialog.hide(value)
				}
			} ],
			controllerAs       : 'ctrlModalVM',
			template           : require('./disableActivityModal.html'),
			clickOutsideToClose: false,
		}).then((dataReturn) => {
			if (dataReturn) {
				this.WorkPlanSrv.deleteActivityItem.delete({ otherActivityCode: activityCode }).$promise.then((dataReturn) => {
					if (dataReturn.status) {
						// se hace set de variable para actualizar los indicadores
						// se comunica con el controlador de Indicadores
						this.WorkPlanIndicatorSrv.setVariable(true)
						this.activities.splice(activityArray, 1)
						this.showModalDeleteSuccess(deleteActivityName)
					} else {
						console.log('Comunications problem with the server')
					}
				}, (data) => {
					console.log(data)
				})
			}
		})
	}

	showModalDeleteSuccess (deleteActivityName) {
		let texts = this.GlobalConfig.appTexts
		let header = {
			createOrEdit    : texts.deleteDialog,
			textCreateOrEdit: texts.deleted,
			itemName        : deleteActivityName,
			nameModal       : texts.modalTypeName.deleted,
			modalType       : texts.modalTypeId.default,
		}

		this.WorkPlanModalSrv.setVariableSuccessDialog(header)
		this.WorkPlanModalSrv.successDialog(header).then((promise) => { })
	}

	toggleSubcategories (assignature) {
		if (assignature.showChilds) {
			assignature.showChilds = false
		} else {
			assignature.showChilds = true
		}
	}

	bitacora (ev) {
		let entries = {}

		entries.params = {
			activityTypeId   : this.GlobalConfig.activityTypeId.activities,
			workplanTeacherId: this.workplanTeacherId,
		}
		entries.title = 'Otras actividades de docencia'
		// Entries(this.entries);
		entries.data = undefined
		$mdDialog.show({
			controller         : 'bitacoraModalCtrl',
			controllerAs       : 'bit',
			template           : require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
			parent             : angular.element(document.body),
			targetEvent        : ev,
			locals             : { data: entries },
			clickOutsideToClose: true,
			fullscreen         : true,
		})
	}
  
}

ActivitiesListCtrl.$inject = [ '$scope', 'WorkPlanSrv', '$mdDialog', 'WorkPlanIndicatorSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'Requests', '$sessionStorage' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/teaching/activities/listActivities/activitiesListCtrl.js